import React from "react";
import Image from "next/image";
interface CardImageProps {
  img: string;
}
const CardImage: React.FC<CardImageProps> = ({ img }) => {
  // Hardcoded static data
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
  const backgroundImage = img ? baseUrl + img : "/images/ghost/card-img.png"; // use a local image from /public

  return (
    <div className=" relative group  h-full overflow-hidden group">
      <Image
        src={backgroundImage}
        alt="industry bg"
        width={810}
        height={393}
        quality={100}
        className="w-full h-full object-cover group-hover:scale-105 group-focus-within:scale-100 transition-all duration-300 ease-in-out rounded-0"
      />
    </div>
  );
};
export default CardImage;
